export const serverURL = 'https://espaceclient.apave.com/';
// export const serverURL = 'https://espaceclient-rec.apavetest.com/';
//export const serverURL = 'http://localhost:3000/';

//export const authServerURL = 'http://localhost:3000/';
// export const authServerURL = 'https://console-espaceclient-rec.apavetest.com/';
export const authServerURL = 'https://console-espaceclient.apave.com/';

export const GOOGLE_APIKEY= "AIzaSyBmA65jwtGzbFP35lNY59yVpcTpBaGYHh0";
export const APP_ID = '9999';
export const privacyURL = `${serverURL}privacy`;

export const apiURL = `${serverURL}v1/`;
export const authApiUrl = `${authServerURL}v1/`;
export const profileURL = `${authServerURL}assets/profiles/`;
export const logoURL = `${authServerURL}assets/logos/`;

export const CATALOGUE_APAVE_TEAM = "6231c96b7fcdd8500ff28e49";
export const CATALOGUE_APAVE_TEAM_PUBLIC = "636a0056fcb10cda72dbbba5";
export const CATALOGUE_CYBER = "640043fdfcb10cda72011dd6";
export const CATALOGUE_CYBER_PUBLIC = "63d38c07d45e04ce02cc77c3";

export const CATALOGUE_VERIFIER = "63ff5c95a003c298ab34714b";
export const CATALOGUE_VERIFIER_PUBLIC = "64004435fcb10cda72011ded";


export const ACTION_STATUSES = ['NEW', 'IN PROGRESS', 'DELAY', 'CLOSED'];
export const STATUSES_COLORS = {
    [ACTION_STATUSES[0]]: '#030F40',
    [ACTION_STATUSES[1]]: '#C9A010',
    [ACTION_STATUSES[2]]: '#DE5252',
    [ACTION_STATUSES[3]]: '#05A969',
    "trainee": "#030F40",
    "order": "#030F40"
}
export const ROLE_ADMIN = 'admin';
export const ROLE_APAVE_CLIENT = 'apaveclient';

export const S3ENDPOINT = 'https://s3.fr-par.scw.cloud/apave-app/';

export const WELDING_CATEGORY_ID = 'Assemblages Permanents';
export const WELDING_APP_ID = '3004';
export const MOBILITY_CATEGORY_ID = 'Mon rapport en mobilité';


export const LEAD_TYPES = [
    'hubspot',
    'chat',
    'userspaces',
    'guestspaces',
    'question'
]

export const LEAD_EXTERNAL_STATUSES = [
    'new',
    'inprogress',
    'valid',
    'close'
]

export const PRODUCT_MODEL_FIELD_TYPES = [
    'TEXT',
    'NUMERIC',
    'DATE',
    'TIME',
    'DATE/TIME'
];

export const PRODUCT_MODEL_FIELD_TYPE_TEXT = PRODUCT_MODEL_FIELD_TYPES[0];
export const PRODUCT_MODEL_FIELD_TYPE_NUMERIC = PRODUCT_MODEL_FIELD_TYPES[1];
export const PRODUCT_MODEL_FIELD_TYPE_DATE = PRODUCT_MODEL_FIELD_TYPES[2];
export const PRODUCT_MODEL_FIELD_TYPE_TIME = PRODUCT_MODEL_FIELD_TYPES[3];
export const PRODUCT_MODEL_FIELD_TYPE_DATETIME = PRODUCT_MODEL_FIELD_TYPES[4];
export const PERPAGE = 50;

export const INDUSTRY_VALUES = [
    'industrial-products-manufacturing', //Produits industriels et fabrication, 
    'energies', //Energies, 
    'infrastructure', //Infrastructure, 
    'construction', //Construction, 
    'transport', //Transport, 
    'food-industry', //Agroalimentaire, 
    'automotive', //Automobile, 
    'consumer-distribution', //Biens de consommation et distribution, 
    'health-medico-social', //Santé et Médico Social, 
    'public-services-local-communities', //Services publics et collectivités locales, 
    'telecommunications-digital', //Télécommunications et Digital, 
    'tertiary', //Tertiaire, 
    'small-businesses-SMEs-selfemployed-workers' //très petites entreprises/PME/travailleurs indépendants
];
export const SERVICES_LOGOS = {
    "ALERT Santé Sécurité": require('assets/images/applications/alert_sante_securite.png'),
    "ALERT Environnement": require('assets/images/applications/alert_environnement.png'),
    "CHECK Santé Sécurité": require('assets/images/applications/check_sante_securite.png'),
    "CHECK Environnement": require('assets/images/applications/check_environnement.png'),
    "CHECK Access": require('assets/images/applications/check_access.png'),
    "CHECK Immo": require('assets/images/applications/check_immo.png'),
    "PILOT Santé Sécurité": require('assets/images/applications/pilot_sante_securite.png'),
    "PILOT Exploitation": require('assets/images/applications/pilot_exploitation.png'),
    "PILOT Veille": require('assets/images/applications/pilot_veille.png'),
    "PILOT Immo": require('assets/images/applications/pilot_immo.png')
}
export const SERVICES_LINK = {
    "ALERT Santé Sécurité": "https://france.apave.com/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/Alert-Sante-Securite-et-Alert-Environnement",
    "ALERT Environnement": null,
    "CHECK Santé Sécurité": "https://france.apave.com/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/Check-Sante-Securite-et-Check-Environnement",
    "CHECK Environnement": "https://france.apave.com/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/Check-Sante-Securite-et-Check-Environnement",
    "CHECK Access": null,
    "CHECK Immo": "https://infrastructures-construction.france.apave.com/fr-FR/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/CheckImmo",
    "PILOT Santé Sécurité": null,
    "PILOT Exploitation": "https://france.apave.com/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/Pilot-Exploitation",
    "PILOT Veille": "https://france.apave.com/Vos-besoins/Decouvrir-nos-gammes-de-solutions-digitales/Pilot-Veille",
    "PILOT Immo": null
}
export const PERIODICITIES = [
    ['AMI100', 'AMI102', 3],
    ['AMI102', 'AMI102', 3],
    ['PRB038', 'AMI102', 3],
    ['PRB040', 'AMI102', 3],
    ['AMI105', 'AMI107', 3],
    ['AMI107', 'AMI107', 3],
    ['PRB035', 'AMI107', 3],
    ['PRB037', 'AMI107', 3],
    ['AMI110', 'AMI112', 3],
    ['AMI112', 'AMI112', 3],
    ['PRB032', 'AMI112', 3],
    ['PRB034', 'AMI112', 3],
    ['AMI115', 'AMI117', 3],
    ['AMI117', 'AMI117', 3],
    ['PRB050', 'AMI117', 3],
    ['PRB051', 'AMI117', 3],
    ['AMR105', 'AMR107', 3],
    ['AMR107', 'AMR107', 3],
    ['AMR100', 'AMR112', 3],
    ['AMR110', 'AMR112', 3],
    ['AMR112', 'AMR112', 3],
    ['AMR112', 'AMR112', 3],
    ['APA020', 'APA225', 3],
    ['APA020', 'APA925', 3],
    ['APR021', 'APR215', 3],
    ['APR022', 'APR225', 3],
    ['APR023', 'APR023', 3],
    ['BAC081', 'BAC085', 5],
    ['BAC085', 'BAC085', 5],
    ['BAC082', 'BAC086', 5],
    ['BAC086', 'BAC086', 5],
    ['BAC083', 'BAC087', 5],
    ['BAC087', 'BAC087', 5],
    ['ELB080', 'ELB180', 3],
    ['ELB180', 'ELB180', 3],
    ['ELB081', 'ELB181', 3],
    ['ELB181', 'ELB181', 3],
    ['ELB090', 'ELB190', 3],
    ['ELB091', 'ELB190', 3],
    ['ELB190', 'ELB190', 3],
    ['FFT001', 'FFT002', 3],
    ['FFT002', 'FFT002', 3],
    ['LMC010', 'LM C015', 5],
    ['LMC011', 'LM C015', 5],
    ['LMC015', 'LM C015', 5],
    ['LMC110', 'LM C115', 5],
    ['LMC111', 'LM C115', 5],
    ['LMC113', 'LM C115', 5],
    ['LMC115', 'LM C115', 5],
    ['LMG030', 'LM G035', 5],
    ['LMG031', 'LM G035', 5],
    ['LMG035', 'LM G035', 5],
    ['LMG130', 'LM G135', 5],
    ['LMG131', 'LM G135', 5],
    ['LMG135', 'LM G135', 5],
    ['LMP010', 'LM P015', 5],
    ['LMP011', 'LM P015', 5],
    ['LMP015', 'LM P015', 5],
    ['LMP110', 'LM P115', 5],
    ['LMP111', 'LM P115', 5],
    ['LMP115', 'LM P115', 5],
    ['NUC001', 'NUC011', 3],
    ['NUC011', 'NUC011', 3],
    ['NUR001', 'NUR011', 3],
    ['NUR011', 'NUR011', 3],
    ['NUR002', 'NUR012', 3],
    ['NUR012', 'NUR012', 3],
    ['NUR021', 'NUR023', 3],
    ['NUR023', 'NUR023', 3],
    ['NUR031', 'NUR033', 3],
    ['NUR033', 'NUR033', 3],
    ['NUR041', 'NUR043', 3],
    ['NUR043', 'NUR043', 3],
    ['NUS001', 'NUS011', 3],
    ['NUS011', 'NUS011', 3],
    ['NUS002', 'NUS012', 3],
    ['NUS012', 'NUS012', 3],
    ['PIA012', 'PI A013', 3],
    ['PIA011', 'PI A013', 3],
    ['PIA013', 'PI A013', 3],
    ['PIA014', 'PI A013', 3],
    ['PIA021', 'PI A023', 3],
    ['PIA022', 'PI A023', 3],
    ['PIA023', 'PI A023', 3],
    ['PIA024', 'PI A023', 3],
    ['PIA031', 'PI A033', 3],
    ['PIA032', 'PI A033', 3],
    ['PIA033', 'PI A033', 3],
    ['PIA034', 'PI A033', 3],
    ['PRB001', 'PR B010', 3],
    ['PRB010', 'PR B010', 3],
    ['PRB503', 'PR B010', 3],
    ['PRB504', 'PR B010', 3],
    ['PRB002', 'PR B020', 4],
    ['PRB020', 'PR B020', 4],
    ['PRB505', 'PR B020', 4],
    ['PRB508', 'PR B020', 4],
    ['PRS001', 'PR S002', 2],
    ['PRS002', 'PR S002', 2],
    ['SDA001', 'SDA011', 3],
    ['SDA011', 'SDA011', 3],
    ['SDA002', 'SDA012', 3],
    ['SDA012', 'SDA012', 3],
    ['SDA003', 'SDA013', 3],
    ['SDA013', 'SDA013', 3],
    ['SDA004', 'SDA014', 3],
    ['SDA014', 'SDA014', 3],
    ['SDA006', 'SDA016', 3],
    ['SDA016', 'SDA016', 3],
    ['SDF001', 'SDF011', 2],
    ['SDF011', 'SDF011', 2],
    ['SDF012', 'SDF012', 3],
    ['SDP001', 'SDP001', 3],
    ['PRB201', 'PR B210', 3],
    ['PRB210', 'PR B210', 3],
    ['PRB202', 'PR B220', 4],
    ['PRB220', 'PR B220', 4],
]
export const CATALOGUE_TYPE_NATIONAL = 'national' // Catalogue Contract National
export const CATALOGUE_TYPE_CLIENTS = 'clients' //Catalogue Clients
export const CATALOGUE_TYPE_GENERAL = 'general' //Catalogue Générique
export const CATALOGUE_TYPE_ESSENTIAL = 'essential' //Catalogue Générique Essentiel
export const CATALOGUE_TYPE_PACK = 'pack'

export const CATALOGUE_TYPES = [
    CATALOGUE_TYPE_NATIONAL,
    //CATALOGUE_TYPE_CLIENTS,    
    CATALOGUE_TYPE_GENERAL,
    CATALOGUE_TYPE_ESSENTIAL,
    CATALOGUE_TYPE_PACK
];
export const DEPARTMENTS = [
    { label: "Ain", id: "01" },
    { label: "Aisne", id: "02" },
    { label: "Allier", id: "03" },
    { label: "Alpes-de-Haute-Provence", id: "04" },
    { label: "Hautes-Alpes", id: "05" },
    { label: "Alpes-Maritimes", id: "06" },
    { label: "Ardèche", id: "07" },
    { label: "Ardennes", id: "08" },
    { label: "Ariège", id: "09" },
    { label: "Aube", id: "10" },
    { label: "Aude", id: "11" },
    { label: "Aveyron", id: "12" },
    { label: "Bouches-du-Rhône", id: "13" },
    { label: "Calvados", id: "14" },
    { label: "Cantal", id: "15" },
    { label: "Charente", id: "16" },
    { label: "Charente-Maritime", id: "17" },
    { label: "Cher", id: "18" },
    { label: "Corrèze", id: "19" },
    { label: "Corse-du-Sud", id: "2A" },
    { label: "Haute-Corse", id: "2B" },
    { label: "Côte-d'Or", id: "21" },
    { label: "Côtes-d'Armor", id: "22" },
    { label: "Creuse", id: "23" },
    { label: "Dordogne", id: "24" },
    { label: "Doubs", id: "25" },
    { label: "Drôme", id: "26" },
    { label: "Eure", id: "27" },
    { label: "Eure-et-Loir", id: "28" },
    { label: "Finistère", id: "29" },
    { label: "Gard", id: "30" },
    { label: "Haute-Garonne", id: "31" },
    { label: "Gers", id: "32" },
    { label: "Gironde", id: "33" },
    { label: "Hérault", id: "34" },
    { label: "Ille-et-Vilaine", id: "35" },
    { label: "Indre", id: "36" },
    { label: "Indre-et-Loire", id: "37" },
    { label: "Isère", id: "38" },
    { label: "Jura", id: "39" },
    { label: "Landes", id: "40" },
    { label: "Loir-et-Cher", id: "41" },
    { label: "Loire", id: "42" },
    { label: "Haute-Loire", id: "43" },
    { label: "Loire-Atlantique", id: "44" },
    { label: "Loiret", id: "45" },
    { label: "Lot", id: "46" },
    { label: "Lot-et-Garonne", id: "47" },
    { label: "Lozère", id: "48" },
    { label: "Maine-et-Loire", id: "49" },
    { label: "Manche", id: "50" },
    { label: "Marne", id: "51" },
    { label: "Haute-Marne", id: "52" },
    { label: "Mayenne", id: "53" },
    { label: "Meurthe-et-Moselle", id: "54" },
    { label: "Meuse", id: "55" },
    { label: "Morbihan", id: "56" },
    { label: "Moselle", id: "57" },
    { label: "Nièvre", id: "58" },
    { label: "Nord", id: "59" },
    { label: "Oise", id: "60" },
    { label: "Orne", id: "61" },
    { label: "Pas-de-Calais", id: "62" },
    { label: "Puy-de-Dôme", id: "63" },
    { label: "Pyrénées-Atlantiques", id: "64" },
    { label: "Hautes-Pyrénées", id: "65" },
    { label: "Pyrénées-Orientales", id: "66" },
    { label: "Bas-Rhin", id: "67" },
    { label: "Haut-Rhin", id: "68" },
    { label: "Rhône", id: "69" },
    { label: "Haute-Saône", id: "70" },
    { label: "Saône-et-Loire", id: "71" },
    { label: "Sarthe", id: "72" },
    { label: "Savoie", id: "73" },
    { label: "Haute-Savoie", id: "74" },
    { label: "Paris", id: "75" },
    { label: "Seine-Maritime", id: "76" },
    { label: "Seine-et-Marne", id: "77" },
    { label: "Yvelines", id: "78" },
    { label: "Deux-Sèvres", id: "79" },
    { label: "Somme", id: "80" },
    { label: "Tarn", id: "81" },
    { label: "Tarn-et-Garonne", id: "82" },
    { label: "Var", id: "83" },
    { label: "Vaucluse", id: "84" },
    { label: "Vendée", id: "85" },
    { label: "Vienne", id: "86" },
    { label: "Haute-Vienne", id: "87" },
    { label: "Vosges", id: "88" },
    { label: "Yonne", id: "89" },
    { label: "Territoire de Belfort", id: "90" },
    { label: "Essonne", id: "91" },
    { label: "Hauts-de-Seine", id: "92" },
    { label: "Seine-St-Denis", id: "93" },
    { label: "Val-de-Marne", id: "94" },
    { label: "Val-D'Oise", id: "95" },
    { label: "Guadeloupe", id: "971" },
    { label: "Martinique", id: "972" },
    { label: "Guyane", id: "973" },
    { label: "La Réunion", id: "974" },
    { label: "Mayotte", id: "976" },
]

export const DOCUMENT_TYPES = [
    "Attestation de stage",
    "Avoir",
    "Avoir frais d'annulation",
    "Certificat de réalisation",
    "Commande signée",
    "Convention signée",
    "Emargement signé",
    "Facture",
    "Frais d'annulation",
    "Livrables signés",
    "OPCO",
    "Résultat échec",
    "Résultat réussite",
]

export const REGIONS = [
    { label: "Ile-de-France", id: "001", tax: 1.1 },
    { label: "Nouvelle-Aquitaine", id: "002" },
    { label: "Guadeloupe", id: "003", tax: 1.15 },
    { label: "Martinique", id: "004", tax: 1.15 },
    { label: "Guyane", id: "005", tax: 1.15 },
    { label: "La Réunion", id: "006", tax: 1.15 },
    { label: "Mayotte", id: "007" },
    { label: "DROM-COM", id: "008" },
    { label: "Bretagne", id: "009" },
    { label: "Pays de la Loire", id: "010" },
    { label: "Hauts-de-France", id: "011" },
    { label: "Corse", id: "012" },
    { label: "Provence-Alpes-Côte d'Azur", id: "013" },
    { label: "Normandie", id: "014" },
    { label: "Grand Est", id: "015" },
    { label: "Bourgogne-Franche-Comté", id: "016" },
    { label: "Auvergne-Rhône-Alpes", id: "017" },
    { label: "Occitanie", id: "018" },
    { label: "Centre-Val de Loire", id: "019" }
]

export const OBSERVATION_STATUS=[
    "noapplicable",
    "lift",
    "tolift"
]